export const INTERVIEW_TYPES = [
  { code: 'virtual', label: 'Virtual (video call)' },
  { code: 'in_person', label: 'In person' },
  { code: 'phone', label: 'Phone' }
];

export const TIMEZONES = [
  { value: 'Asia/Kolkata', label: 'India (IST)' },
  { value: 'Asia/Dubai', label: 'Gulf (GST)' },
  { value: 'Europe/London', label: 'UK (GMT/BST)' },
  { value: 'America/New_York', label: 'US Eastern' },
  { value: 'UTC', label: 'UTC' }
];

export function emptyInterviewSchedule(overrides = {}) {
  return {
    interviewType: 'virtual',
    scheduledAt: '',
    durationMinutes: 60,
    timezone: 'Asia/Kolkata',
    location: '',
    meetingLink: '',
    instructions: '',
    dressCode: '',
    panelists: '',
    ...overrides
  };
}

export function interviewScheduleValid(schedule, { requireInstructions = false } = {}) {
  const when = schedule?.scheduledAtLocal || schedule?.scheduledAt;
  if (!when) return false;
  if (schedule.interviewType === 'virtual' && !schedule.meetingLink?.trim()) return false;
  if (schedule.interviewType === 'in_person' && !schedule.location?.trim()) return false;
  if (requireInstructions && !schedule.instructions?.trim()) return false;
  return true;
}

export function needsInterviewSchedule(initialStage, nextStage) {
  return nextStage === 'interview' && initialStage !== 'interview' && initialStage === 'selected';
}

/** datetime-local value from ISO */
export function toDatetimeLocal(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = n => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** ISO from datetime-local */
export function fromDatetimeLocal(local) {
  if (!local) return '';
  const d = new Date(local);
  return Number.isNaN(d.getTime()) ? '' : d.toISOString();
}

export function canCandidateManageInterview(app) {
  if (app.stage !== 'interview' || !app.interviewSchedule) return false;
  const s = app.interviewSchedule.status;
  return s === 'scheduled' || s === 'confirmed' || s === 'reschedule_requested';
}

/** Candidate may accept/confirm attendance at the scheduled time. */
export function canCandidateAcceptInterview(sched) {
  if (!sched || sched.status === 'cancelled' || sched.status === 'reschedule_requested') {
    return false;
  }
  if (sched.status === 'confirmed') return false;
  return sched.status === 'scheduled' || Boolean(sched.scheduledAt);
}
